import React from 'react';

export const AgeVerificationComponent: React.FC = () => (
  <div className="age-verification-container">
    <div className="age-verification-icon">21+</div>
    <div className="age-verification-text">Check ID</div>
  </div>
);
